export const LEAD_SOURCE_CODES = ['inbound_form', 'scraper', 'manual', 'import', 'api'];
export const LEAD_SOURCE_LABELS = {
    inbound_form: 'Inbound formulier',
    scraper: 'Scraper',
    manual: 'Handmatig',
    import: 'CSV import',
    api: 'API',
};
//# sourceMappingURL=leadSources.js.map